/**
 * This file is autogenerated by py_nats_stub_gen
 * Do not edit this file manually!!
 * => Instead, re-generate it. Check the py-nats-stub-gen repo for more info
 **/
import type { ApiCaller } from "../../wire/ApiCaller";
import type {
  CanConnectResponse,
  CreateAdoSyncSessionRequest,
  CreateAdoSyncSessionResponse,
  GetAdoArtMappingSourcesResponse,
  GetAdoIterationsRequest,
  GetAdoIterationsResponse,
  GetAdoKanbanConfigsRequest,
  GetAdoKanbanConfigsResponse,
  GetAdoPatResponse,
  GetAdoProjectIdResponse,
  GetAdoProjectsResponse,
  GetAdoTeamMappingResponse,
  GetAdoTeamMappingSourcesResponse,
  GetAdoUsernameResponse,
  GetAdoWebhookEndpointResponse,
  GetAdoWorkItemFieldsRequest,
  GetAdoWorkItemFieldsResponse,
  GetAdoWorkItemTypesResponse,
  GetAdoWorkitemLinkTypesResponse,
  NoData,
  SetAdoArtMappingSourcesRequest,
  SetAdoPatRequest,
  SetAdoProjectIdRequest,
  SetAdoTeamMappingRequest,
  SetAdoTeamMappingSourcesRequest,
  SetAdoUsernameRequest,
  ValidateAdoAreaPathRequest,
  ValidateAdoIterationPathRequest,
  ValidateAdoPathResponse,
} from "./models";
import {
  canConnectResponseSchema,
  createAdoSyncSessionResponseSchema,
  getAdoArtMappingSourcesResponseSchema,
  getAdoIterationsResponseSchema,
  getAdoKanbanConfigsResponseSchema,
  getAdoPatResponseSchema,
  getAdoProjectIdResponseSchema,
  getAdoProjectsResponseSchema,
  getAdoTeamMappingResponseSchema,
  getAdoTeamMappingSourcesResponseSchema,
  getAdoUsernameResponseSchema,
  getAdoWebhookEndpointResponseSchema,
  getAdoWorkItemFieldsResponseSchema,
  getAdoWorkItemTypesResponseSchema,
  getAdoWorkitemLinkTypesResponseSchema,
  noDataSchema,
  validateAdoPathResponseSchema,
} from "./schemas";

export class AlmconnectionAdoApiClient {
  constructor(private caller: ApiCaller) {}

  async canConnect(connectionId: string, timeout?: number): Promise<CanConnectResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.ado.connections.${connectionId}.can_connect.get",
        variables: { connectionId: String(connectionId) },
      },
      "canConnect",
      {},
      { schema: canConnectResponseSchema, timeout },
    );
  }

  async getAdoUsername(connectionId: string, timeout?: number): Promise<GetAdoUsernameResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.ado.connections.${connectionId}.username.get",
        variables: { connectionId: String(connectionId) },
      },
      "getAdoUsername",
      {},
      { schema: getAdoUsernameResponseSchema, timeout },
    );
  }

  async setAdoUsername(
    payload: SetAdoUsernameRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.ado.connections.${connectionId}.username.set",
        variables: { connectionId: String(connectionId) },
      },
      "setAdoUsername",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async getAdoPat(connectionId: string, timeout?: number): Promise<GetAdoPatResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.ado.connections.${connectionId}.pat.get",
        variables: { connectionId: String(connectionId) },
      },
      "getAdoPat",
      {},
      { schema: getAdoPatResponseSchema, timeout },
    );
  }

  async setAdoPat(
    payload: SetAdoPatRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.ado.connections.${connectionId}.pat.set",
        variables: { connectionId: String(connectionId) },
      },
      "setAdoPat",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async getAdoProjects(connectionId: string, timeout?: number): Promise<GetAdoProjectsResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.ado.connections.${connectionId}.projects.get",
        variables: { connectionId: String(connectionId) },
      },
      "getAdoProjects",
      {},
      { schema: getAdoProjectsResponseSchema, timeout },
    );
  }

  async getAdoProjectId(connectionId: string, timeout?: number): Promise<GetAdoProjectIdResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.ado.connections.${connectionId}.project_id.get",
        variables: { connectionId: String(connectionId) },
      },
      "getAdoProjectId",
      {},
      { schema: getAdoProjectIdResponseSchema, timeout },
    );
  }

  async setAdoProjectId(
    payload: SetAdoProjectIdRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.ado.connections.${connectionId}.project_id.set",
        variables: { connectionId: String(connectionId) },
      },
      "setAdoProjectId",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async getAdoIterations(
    payload: GetAdoIterationsRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<GetAdoIterationsResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.ado.connections.${connectionId}.iterations.get",
        variables: { connectionId: String(connectionId) },
      },
      "getAdoIterations",
      payload,
      { schema: getAdoIterationsResponseSchema, timeout },
    );
  }

  async getAdoTeamMapping(
    connectionId: string,
    timeout?: number,
  ): Promise<GetAdoTeamMappingResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.ado.connections.${connectionId}.team_mapping.get",
        variables: { connectionId: String(connectionId) },
      },
      "getAdoTeamMapping",
      {},
      { schema: getAdoTeamMappingResponseSchema, timeout },
    );
  }

  async setAdoTeamMapping(
    payload: SetAdoTeamMappingRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.ado.connections.${connectionId}.team_mapping.set",
        variables: { connectionId: String(connectionId) },
      },
      "setAdoTeamMapping",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async getAdoTeamMappingSources(
    connectionId: string,
    teamId: number,
    timeout?: number,
  ): Promise<GetAdoTeamMappingSourcesResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.ado.connections.${connectionId}.teams.${teamId}.mapping_sources.get",
        variables: { connectionId: String(connectionId), teamId: String(teamId) },
      },
      "getAdoTeamMappingSources",
      {},
      { schema: getAdoTeamMappingSourcesResponseSchema, timeout },
    );
  }

  async setAdoTeamMappingSources(
    payload: SetAdoTeamMappingSourcesRequest,
    connectionId: string,
    teamId: number,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.ado.connections.${connectionId}.teams.${teamId}.mapping_sources.set",
        variables: { connectionId: String(connectionId), teamId: String(teamId) },
      },
      "setAdoTeamMappingSources",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async getAdoArtMappingSources(
    connectionId: string,
    artId: number,
    timeout?: number,
  ): Promise<GetAdoArtMappingSourcesResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.ado.connections.${connectionId}.arts.${artId}.mapping_sources.get",
        variables: { connectionId: String(connectionId), artId: String(artId) },
      },
      "getAdoArtMappingSources",
      {},
      { schema: getAdoArtMappingSourcesResponseSchema, timeout },
    );
  }

  async setAdoArtMappingSources(
    payload: SetAdoArtMappingSourcesRequest,
    connectionId: string,
    artId: number,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.ado.connections.${connectionId}.arts.${artId}.mapping_sources.set",
        variables: { connectionId: String(connectionId), artId: String(artId) },
      },
      "setAdoArtMappingSources",
      payload,
      { schema: noDataSchema, timeout },
    );
  }

  async getAdoWebhookEndpoint(
    connectionId: string,
    timeout?: number,
  ): Promise<GetAdoWebhookEndpointResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.ado.connections.${connectionId}.webhook_endpoint.get",
        variables: { connectionId: String(connectionId) },
      },
      "getAdoWebhookEndpoint",
      {},
      { schema: getAdoWebhookEndpointResponseSchema, timeout },
    );
  }

  async getAdoWorkItemTypes(
    connectionId: string,
    timeout?: number,
  ): Promise<GetAdoWorkItemTypesResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.ado.connections.${connectionId}.work_item_types.get",
        variables: { connectionId: String(connectionId) },
      },
      "getAdoWorkItemTypes",
      {},
      { schema: getAdoWorkItemTypesResponseSchema, timeout },
    );
  }

  async getAdoWorkItemFields(
    payload: GetAdoWorkItemFieldsRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<GetAdoWorkItemFieldsResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.ado.connections.${connectionId}.work_item_fields.get",
        variables: { connectionId: String(connectionId) },
      },
      "getAdoWorkItemFields",
      payload,
      { schema: getAdoWorkItemFieldsResponseSchema, timeout },
    );
  }

  async getAdoWorkitemLinkTypes(
    connectionId: string,
    timeout?: number,
  ): Promise<GetAdoWorkitemLinkTypesResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.ado.connections.${connectionId}.workitem_link_types.get",
        variables: { connectionId: String(connectionId) },
      },
      "getAdoWorkitemLinkTypes",
      {},
      { schema: getAdoWorkitemLinkTypesResponseSchema, timeout },
    );
  }

  async validateAdoAreaPath(
    payload: ValidateAdoAreaPathRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<ValidateAdoPathResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.ado.connections.${connectionId}.validate_area_path.get",
        variables: { connectionId: String(connectionId) },
      },
      "validateAdoAreaPath",
      payload,
      { schema: validateAdoPathResponseSchema, timeout },
    );
  }

  async validateAdoIterationPath(
    payload: ValidateAdoIterationPathRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<ValidateAdoPathResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.ado.connections.${connectionId}.validate_iteration_path.get",
        variables: { connectionId: String(connectionId) },
      },
      "validateAdoIterationPath",
      payload,
      { schema: validateAdoPathResponseSchema, timeout },
    );
  }

  async createAdoSyncSession(
    payload: CreateAdoSyncSessionRequest,
    connectionId: string,
    piSessionId: string,
    timeout?: number,
  ): Promise<CreateAdoSyncSessionResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.ado.connections.${connectionId}.pi_sessions.${piSessionId}.sync_session.create",
        variables: { connectionId: String(connectionId), piSessionId: String(piSessionId) },
      },
      "createAdoSyncSession",
      payload,
      { schema: createAdoSyncSessionResponseSchema, timeout },
    );
  }

  async getAdoKanbanConfigs(
    payload: GetAdoKanbanConfigsRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<GetAdoKanbanConfigsResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almconnection.v1.ado.connections.${connectionId}.kanban_configs.get",
        variables: { connectionId: String(connectionId) },
      },
      "getAdoKanbanConfigs",
      payload,
      { schema: getAdoKanbanConfigsResponseSchema, timeout },
    );
  }
}
